import React, { createContext, useContext } from 'react';

interface ApiContextType {
  // API client uses HttpOnly cookies for authentication
  // No token management needed
  readonly initialized: boolean;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export function ApiProvider({ children }: { children: React.ReactNode }) {
  // API client automatically handles authentication via HttpOnly cookies
  // No token management or setup required
  
  return (
    <ApiContext.Provider value={{ initialized: true }}>
      {children}
    </ApiContext.Provider>
  );
}

export function useApi() {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
} 